import React from 'react';

type SkeletonAnimation = 'pulse' | 'wave' | 'none';
type SkeletonChartVariant = 'bar' | 'line' | 'pie';

interface SkeletonChartProps {
  variant?: SkeletonChartVariant;
  barCount?: number;
  animation?: SkeletonAnimation;
}

export const SkeletonChart: React.FC<SkeletonChartProps> = ({
  variant = 'bar',
  barCount = 6,
  animation = 'wave',
}) => {
  if (variant === 'pie') {
    return (
      <div className="skeleton-chart skeleton-chart-pie-wrapper">
        <div className="skeleton skeleton-chart-pie" />
      </div>
    );
  }

  const barIndexes = Array.from({ length: barCount });

  return (
    <div className={`skeleton-chart skeleton-chart-${variant}`}>
      {barIndexes.map((_, index) => (
        <div
          key={`chart-bar-${index}`}
          className="skeleton skeleton-chart-bar"
          style={{ height: `${40 + ((index * 13) % 60)}%` }}
        />
      ))}
    </div>
  );
};

export default SkeletonChart;
